import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  width: 100%;
  padding: 20px;
  position: relative;
  &::before {
    content: '';
    position: absolute;
    inset: 0;
    z-index: 1;
  }
`;

export const MainContent = styled.div`
  width: 100%;
  max-width: 460px;
  padding: 32px;
  background: white;
  border-radius: 20px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
  z-index: 2;
  position: relative;
  backdrop-filter: blur(12px);
  border: 1px solid rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const LogoContainer = styled.div`
  margin-bottom: 24px;
  
  img {
    height: 60px;
    width: auto;
    filter: drop-shadow(0 4px 6px rgba(0, 0, 0, 0.1));
  }
`;

export const Title = styled.h1`
  font-size: 22px;
  color: #dc2626;
  text-align: center;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  margin-bottom: 24px;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
`;

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const Label = styled.label`
  font-size: 19px;
  font-weight: 800;
  color: #374151;
`;

export const Input = styled.input`
  padding: 12px 14px;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  font-size: 16px;
  transition: all 0.3s ease;
  background: rgba(255, 255, 255, 0.9);

  &:focus {
    outline: none;
    border-color: #dc2626;
    box-shadow: 0 0 0 2px rgba(220, 38, 38, 0.1);
  }

  &::placeholder {
    color: #9ca3af;
  }
`;

export const Button = styled.button`
  padding: 12px 20px;
  border: none;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  
  ${props => props.variant === 'primary' && `
    background-color: #dc2626;
    color: white;
    &:hover {
      background-color: #b91c1c;
    }
    &:disabled {
      background-color: #fca5a5;
      cursor: not-allowed;
    }
  `}

  ${props => props.variant === 'secondary' && `
    background-color: #6b7280;
    color: white;
    &:hover {
      background-color: #4b5563;
    }
  `}
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 16px;
`;

export const ErrorMessage = styled.div`
  color: #dc2626;
  font-size: 14px;
  padding: 10px 14px;
  background-color: #fee2e2;
  border-radius: 8px;
  border: 1px solid #fecaca;
  display: flex;
  align-items: center;
  gap: 8px;
  text-align: center;

  &::before {
    content: '⚠️';
  }
`;

export const SuccessMessage = styled.div`
  color: #059669;
  font-size: 14px;
  padding: 10px 14px;
  background-color: #d1fae5;
  border-radius: 8px;
  border: 1px solid #a7f3d0;
  display: flex;
  align-items: center;
  gap: 8px;
  text-align: center;

  &::before {
    content: '✅';
  }
`;

export const OtpContainer = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
  margin: 20px 0;
`;

export const OtpInput = styled.input`
  width: 48px;
  height: 48px;
  text-align: center;
  font-size: 22px;
  font-weight: 600;
  border: 2px solid #e5e7eb;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.9);
  transition: all 0.3s ease;

  &:focus {
    outline: none;
    border-color: #dc2626;
    box-shadow: 0 0 0 2px rgba(220, 38, 38, 0.1);
  }
`;

export const WarningText = styled.p`
  color: #dc2626;
  font-size: 15px;
  text-align: center;
  margin: 20px 0;
  padding: 14px;
  background-color: #fee2e2;
  border-radius: 8px;
  border: 1px solid #fecaca;
  font-weight: 500;

  &::before {
    content: '⚠️';
    margin-right: 6px;
  }
`;

export const ResendOtpText = styled.span`
  color: ${props => props.disabled ? '#6b7280' : '#dc2626'};
  font-size: 14px;
  text-align: center;
  cursor: ${props => props.disabled ? 'default' : 'pointer'};
  display: block;
  margin-top: 12px;
  font-weight: 500;
  transition: all 0.3s ease;

  &:hover {
    text-decoration: ${props => props.disabled ? 'none' : 'underline'};
    color: ${props => props.disabled ? '#6b7280' : '#b91c1c'};
  }
`;
